var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHappyBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F6FFED",
  d: "M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#B7EB8F",
  d: "M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#HappyBadge_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#52C41A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.332 13.334s1 1.333 2.667 1.333 2.666-1.333 2.666-1.333M14 10h.006M10 10h.006m8.66 2a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0m-4.333-2a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0m-4 0a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "HappyBadge_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 4h16v16H4z"
})))));
export { SvgHappyBadge as ReactComponent };
export default __webpack_public_path__ + "assets/images/HappyBadge.45baafb878770c23bbe074aebaa4dd78.svg";